import emojiRegex from 'emoji-regex';
import { getaddressFormat } from './addressRegexAndFormats';
export const addressRegex = /^(?=.*[a-zA-Z0-9])[a-zA-Z0-9\s,.'-]{5,100}$/
export const numberValidationHelper = {
    maxLimit: 999999999999.9999,
    maxLimitString: '1,000,000,000,000',
    minLimit: 0,
    minLimitString: '0'
}
export const validations = {
    requiredValidator: (required = true, message = 'Is required') => {
        return {
            required: required,
            message: message
        }
    },
    patternValidator: (fieldName, network) => {
        return () => ({
            validator(_, value) {
                if (value && !getaddressFormat(network, value)) {
                    return Promise.reject(new Error(`Please enter a valid ${network?.toUpperCase()} ${fieldName}`));
                }
                return Promise.resolve();
            }
        });
    },
    numberValidator: (fieldName) => {
        return () => ({
            validator(_, value) {
                if (value === 0) {
                    return Promise.reject(new Error(`Must be greater than 0.`));
                }
                return Promise.resolve();
            },
        });
    },
}
const htmlRegex = {
    test: function (str) {
        if (!str || typeof str !== 'string') return false;
        let inTag = false;
        for (const char of str) {
            if (char === '<') {
                inTag = true;
            } else if (char === '>' && inTag) {
                return true;
            }
        }
        return false;
    }
};
export const validateContentRules = (_, value) => {
    const emojiregex = emojiRegex()
    if (value && (htmlRegex.test(value) || value.match(emojiregex))) {
        return Promise.reject("Please enter valid content");
    }
    return Promise.resolve();
}
export const validateAddressType = (value, network) => {
    if (!value || !network) {
        return Promise.resolve();
    }
    const address = value.trim();
    const isValidAddress = addressRegex[network?.toLowerCase()]?.test(address)
    if (!isValidAddress) {
        return Promise.reject("Address is not valid, Please enter a valid address according to the network selected")
    }
    return Promise.resolve();

};
export const validateTronAddressOrHash = (_, value) => {
    const trxHashRegex = /^[A-Fa-f0-9]{64}$/;
    const tronAddressRegex = /^T[a-zA-Z0-9]{33}$/;

    if (!value) {
        return Promise.resolve();
    }
    if (trxHashRegex.test(value) || tronAddressRegex.test(value)) {
        return Promise.resolve();
    }

    return Promise.reject(new Error('Invalid hash.'));
};
